import { Col, Layout, Row, Space, Tabs, TabsProps } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ChatIcon, WhiteEditIcon } from 'assets/svg';
import { MainLayout } from 'components';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import { useEffect, useRef, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useUser } from 'contexts/User';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { openNotificationWithIcon } from 'utils/notification';
import CapitalApi from 'apis/CapitalApi';
import AllocationCapital from 'components/Modules/Approve/ApproveCapital/AllocationCapitalSider';
import PlantAllocateTab1 from 'components/Modules/PlantAllocate/PlantAllocateTab1';
import PlantAllocateTab2 from 'components/Modules/PlantAllocate/PlantAllocateTab2';
import PlantAllocateTab3 from 'components/Modules/PlantAllocate/PlantAllocateTab3';
import AllocateApi from 'apis/Allocate';
import handleError401 from 'utils/handleError401';
import Sider from 'antd/es/layout/Sider';
import AllocationCapitalSider from 'components/Modules/Approve/ApproveCapital/AllocationCapitalSider';

const ApproveDetail = () => {
  const { user } = useUser();
  const childRef = useRef<any>(null);
  const CapitalDetail = useLocation().state as any;
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const history = useHistory();

  const [detailCapitalShop, setDetailCapitalShop] = useState<any>();
  const [loading, setLoading] = useState(false);
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { mutate: getDetailCapitalShop, isLoading: isLoading } = useMutation(
    ['getDetail', detailCapitalShop, user],
    () =>
      AllocateApi.getDetailCapitalShop({
        shop_id: CapitalDetail?.record?.id,
        capital_year: CapitalDetail?.year,
      }),
    {
      onSuccess: (response) => {
        setDetailCapitalShop(response.data);
      },
      onError: (error: any) => {
        setDetailCapitalShop(undefined);
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  useEffect(() => {
    setTitle(CapitalDetail?.record?.name);
    setBreadcrumb([
      {
        title: (
          <>
            <a href="/">Phê duyệt</a>
          </>
        ),
      },
      {
        title: <a href="/approve-order-list">Phê duyệt phân bổ</a>,
      },
      { title: <a href="">{CapitalDetail?.record?.name}</a> },
    ]);
    getDetailCapitalShop();
  }, [page, page_size]);

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Phân bố tỷ trọng vốn tồn',
      children: detailCapitalShop &&
        detailCapitalShop.capital_ratio &&
        detailCapitalShop.capital_ratio_pof && (
          <PlantAllocateTab1 detailCapitalShop={detailCapitalShop} />
        ),
    },
    {
      key: '2',
      label: 'Khai báo tủ kinh doanh',
      children: detailCapitalShop && (
        <PlantAllocateTab2
          id={detailCapitalShop.id}
          year={CapitalDetail?.year}
          shop_id={CapitalDetail?.record?.id}
        />
      ),
    },
    {
      key: '3',
      label: 'Khai báo tỷ trọng vốn theo dòng hàng',
      children: detailCapitalShop && (
        <PlantAllocateTab3 cap_shop_id={detailCapitalShop.id} />
      ),
    },
  ];

  const onGoToAddTracking = () => {
    console.log('go to add');
  };

  const onGoToReport = () => {
    console.log('go to report');
  };

  function openChat() {
    console.log('Function not implemented.');
  }

  const checkBeforeSendApprove = async () => {
    if (childRef && childRef.current) {
      childRef.current.checkBeforeSendApprove();
    }
  };

  const { mutate: refuseCapital } = useMutation(CapitalApi.putUpdateStatus, {
    onSuccess: (data: any) => {
      setLoading(false);
      if (data.status == 'success') {
        openNotificationWithIcon('success', 'Từ chối thành công');
      }
      history.push(`/approve-order-list`);
    },
    onError: () => {
      setLoading(false);
      openNotificationWithIcon('error', 'Từ chối thất bại');
    },
  });

  const { mutate: approveCapital } = useMutation(CapitalApi.putUpdateStatus, {
    onSuccess: (data: any) => {
      setLoading(false);
      if (data.status == 'success') {
        openNotificationWithIcon('success', 'Phê duyệt thành công');
      }
      history.push(`/approve-order-list`);
    },
    onError: () => {
      setLoading(false);
      openNotificationWithIcon('error', 'Phê duyệt thất bại');
    },
  });

  const { mutate: requestCapital } = useMutation(CapitalApi.putUpdateStatus, {
    onSuccess: (data: any) => {
      setLoading(false);
      if (data.status == 'success') {
        openNotificationWithIcon('success', 'Yêu cầu thành công');
      }
      history.push(`/approve-order-list`);
    },
    onError: () => {
      setLoading(false);
      openNotificationWithIcon('error', 'Yêu cầu thất bại');
    },
  });

  const handleRefuse = async (record: any) => {
    const list_capital = [];
    if (
      user?.role.includes('asm')
        ? CapitalDetail.record?.asm_approve_status != 2 &&
          CapitalDetail.record?.status != 2
        : CapitalDetail.record?.status != 3
    ) {
      list_capital.push(record.id);
    } else {
      openNotificationWithIcon(
        'error',
        'Trạng thái cửa hàng phải là Chờ Duyệt'
      );
    }
    if (list_capital.length > 0) {
      const params = {
        list_capital_id: list_capital,
        status: user?.role.includes('asm') ? 2 : 3,
        reject_reason: 'Không đạt yêu cầu',
      };
      setLoading(true);
      refuseCapital(params);
    }
  };

  const handleApprove = async (record: any) => {
    const list_capital = [];
    if (
      user?.role.includes('asm')
        ? CapitalDetail.record?.asm_approve_status == 0
        : CapitalDetail.record?.status == 1
    ) {
      list_capital.push(record.id);
    } else {
      openNotificationWithIcon(
        'error',
        'Trạng thái cửa hàng phải là Chờ Duyệt'
      );
    }
    if (list_capital.length > 0) {
      const params = {
        list_capital_id: list_capital,
        status: user?.role.includes('asm') ? 1 : 2,
        reject_reason: '',
      };
      setLoading(true);
      approveCapital(params);
    }
  };

  const handleRequest = async (record: any) => {
    const list_capital = [];
    if (record.status == 3) {
      list_capital.push(record.id);
    } else {
      openNotificationWithIcon('error', 'Trạng thái cửa hàng phải là Từ chối');
    }
    if (list_capital.length > 0) {
      const params = {
        list_capital_id: list_capital,
        status: 1,
        reject_reason: '',
      };
      setLoading(true);
      requestCapital(params);
    }
  };

  return (
    <MainLayout isLoading={loading && isLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-4"
      >
        <Col span={8}>
          <p
            className="text-primary-50 font-medium mt-1"
            onClick={() => history.push(`/approve-order-list`, {})}
          >
            &lt; Phê duyệt
          </p>
        </Col>
        <Col span={16} className="flex justify-end">
          {user?.plantCode != 1000 &&
            (user?.role.includes('cua_hang_truong') ? (
              <Space>
                {/* <Button
                  noneBold={true}
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={openChat}
                >
                  <ChatIcon />
                </Button> */}
                <Button
                  disabled={detailCapitalShop?.status == 3 ? false : true}
                  bgColor={
                    detailCapitalShop?.status == 3
                      ? 'bg-primary-50'
                      : 'bg-gray-300'
                  }
                  color={'text-white'}
                  border={'border-white'}
                  onClick={() => {
                    handleRequest(detailCapitalShop);
                  }}
                >
                  <WhiteEditIcon />
                  Yêu cầu phê duyệt
                </Button>
              </Space>
            ) : (
              <Space>
                {/* <Button
                  noneBold={true}
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={openChat}
                >
                  <ChatIcon />
                </Button> */}
                <Button
                  disabled={
                    user?.role.includes('asm')
                      ? CapitalDetail.record?.asm_approve_status == 2 ||
                        CapitalDetail.record?.status == 2
                      : CapitalDetail.record?.status == 3
                  }
                  bgColor={
                    (
                      user?.role.includes('asm')
                        ? CapitalDetail.record?.asm_approve_status != 2 &&
                          CapitalDetail.record?.status != 2
                        : CapitalDetail.record?.status != 3
                    )
                      ? 'bg-red-500'
                      : 'bg-gray-300'
                  }
                  onClick={() => {
                    handleRefuse(detailCapitalShop);
                  }}
                >
                  Từ chối
                </Button>
                <Button
                  disabled={
                    user?.role.includes('asm')
                      ? CapitalDetail.record?.asm_approve_status != 0
                      : CapitalDetail.record?.status != 1
                  }
                  bgColor={
                    (
                      user?.role.includes('asm')
                        ? CapitalDetail.record?.asm_approve_status == 0
                        : CapitalDetail.record?.status == 1
                    )
                      ? 'bg-green-500'
                      : 'bg-gray-300'
                  }
                  onClick={() => {
                    handleApprove(detailCapitalShop);
                  }}
                >
                  Duyệt
                </Button>
              </Space>
            ))}
        </Col>
      </Row>
      <Layout className="relative p-0 m-0">
        <Content>
          <Tabs
            items={items}
            defaultActiveKey="1"
            className="-my-5"
            tabBarExtraContent={
              <span
                className="border border-solid boder-primary-50 rounded-lg font-sans text-sm py-1 px-2 leading-5 bg-gray-100 uppercase"
                style={{ color: '#4da6ff' }}
              >
                {(user?.role.includes('asm') &&
                  (CapitalDetail.record?.asm_approve_status == 0
                    ? 'Chưa duyệt'
                    : CapitalDetail.record?.asm_approve_status == 1
                    ? 'Đã duyệt'
                    : 'Từ chối')) ||
                  (detailCapitalShop?.status == 0
                    ? 'Mới tạo'
                    : detailCapitalShop?.status == 1
                    ? 'Chờ phê duyệt'
                    : detailCapitalShop?.status == 2
                    ? 'Đã duyệt'
                    : 'Từ chối')}
                {/* {detailCapitalShop?.status == 0
                  ? 'Mới tạo'
                  : detailCapitalShop?.status == 1
                  ? 'Chờ phê duyệt'
                  : detailCapitalShop?.status == 2
                  ? 'Đã duyệt'
                  : 'Từ chối'} */}
              </span>
            }
          />
        </Content>
        <Sider
          width="25%"
          style={{ marginLeft: '1%', backgroundColor: 'white' }}
        >
          <AllocationCapitalSider
            capitalDetail={CapitalDetail?.record}
            shopCapital={detailCapitalShop}
          />
        </Sider>
      </Layout>
    </MainLayout>
  );
};

export default ApproveDetail;
